import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next'
import ArrowRight from '@/assets/images/icons/arrow-right.svg'
/**
 * Props for `TwoColumnImages`.
 */
export type TwoColumnImagesProps =
  SliceComponentProps<Content.TwoColumnImagesSlice>;

/**
 * Component for "TwoColumnImages" Slices.
 */
const TwoColumnImages: FC<TwoColumnImagesProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation} 
      className={` ${slice.primary.background?.toLowerCase() as string} font-fellix pt-10 pb-24`}
    >
      <div className="max-w-[850px] mx-auto">
        {slice.primary.title ?
        <article className="prose prose-h2:!text-[28px] text-center max-w-none">
          <PrismicRichText field={slice.primary.title} />
        </article>
        :<></>}
          <div className="grid grid-cols-12 gap-6 text-left mt-12 mx-4">
            {slice.primary.columns.map((item: any, index: number)=>{
                return (
                    <div className="col-span-12 md:col-span-6 bg-white" key={index}>
                      <PrismicNextLink field={item.link}>
                        <PrismicNextImage field={item.image} className="aspect-4/3 w-full object-cover" fallbackAlt=""/>
                        <div className="px-4 py-8 text-[20px] font-semibold">
                        {item.title ?
                        <PrismicRichText field={item.title ? item.title : "" } />
                        : <div aria-hidden="true">&nbsp;</div>}
                        <PrismicRichText field={item.paragaraph ? item.paragaraph :""} />
                        <ArrowRight className="mt-4"/>
                        </div>
                      </PrismicNextLink>
                    </div>
                )
            })}
            </div>
        </div>
    </section>
  );
};

export default TwoColumnImages;
